import CkPlugin from './CkPlugin';

export default class SeparatorPlugin extends CkPlugin {
    createNode() {
        let nodeElement = document.createElement("span");
        nodeElement.className = 'ck ck-toolbar__separator';
        return nodeElement;
    }
}